// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.disabled-formio-component{cursor:not-allowed;pointer-events:none;opacity:0.8}
`, "",{"version":3,"sources":["webpack://./src/FormioBuilderComponent/styles/index.scss"],"names":[],"mappings":"AAAA,2BACI,kBAAmB,CACnB,mBAAoB,CACpB,WAAY","sourcesContent":[".disabled-formio-component {\n    cursor: not-allowed;\n    pointer-events: none;\n    opacity: 0.8;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
